import React from 'react'
import { useAuth } from '../../hooks/useAuth'
import { useSearchParams } from 'react-router-dom';
import useDarkOffersBackground from '../../hooks/useDarkOffersBackground';

export default function CPXResearch() {

    const { user } = useAuth();
    const [params] = useSearchParams();
    useDarkOffersBackground();

    // CPX redirects back here after a survey with ?cpx_message_id={message_id}
    // (configured as the dashboard Redirect Url). Feeding it to the wall lets
    // CPX render the success/failure message. Accepts `message_id` too.
    const messageId = params.get('cpx_message_id') || params.get('message_id');
    const wallSrc = `https://offers.cpx-research.com/index.php?app_id=21139&ext_user_id=${user?.id}&username=${user?.username}&email=${user?.email}${messageId ? `&message_id=${encodeURIComponent(messageId)}` : ''}`;

  return (
    <iframe width="100%" frameBorder="0" height="1000px" src={wallSrc}></iframe>
  )
}
